import { render, staticRenderFns } from "./CardRightBlock.vue?vue&type=template&id=12ef23d7"
import script from "./CardRightBlock.vue?vue&type=script&lang=js"
export * from "./CardRightBlock.vue?vue&type=script&lang=js"
import style0 from "./CardRightBlock.vue?vue&type=style&index=0&id=12ef23d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports